import React, { HTMLProps, PropsWithChildren } from 'react';

import useStyles from './styles';

interface Props extends HTMLProps<HTMLHeadingElement> {
    align?: 'left' | 'center' | 'right';
    smaller?: boolean;
    blacken?: boolean;
    variant: 'h1' | 'h2';
}

const Title: React.FC<PropsWithChildren<Props>> = ({
    variant = 'h1',
    align = 'center',
    className,
    children,
    smaller = false,
    blacken = false,
    ...props
}) => {
    const { classes, cx } = useStyles({ smaller, blacken });
    const Component = variant;

    return (
        <Component
            className={cx(
                classes.root,
                {
                    [classes.h1]: variant === 'h1',
                    [classes.h2]: variant === 'h2',
                    [classes._left]: align === 'left',
                    [classes._center]: align === 'center',
                    [classes._right]: align === 'right'
                },
                className
            )}
            {...props}
        >
            {children}
        </Component>
    );
};
export default Title;
